import { useEffect } from "react";

export function useScrollReveal(selector = ".reveal") {
  useEffect(() => {
    // Small positive rootMargin so elements near the top of a freshly-loaded
    // page trigger the observer even before the scroll-to-top settles.
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("revealed");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -20px 0px" }
    );

    // Use rAF so elements are guaranteed in the DOM before we observe
    const raf = requestAnimationFrame(() => {
      document.querySelectorAll(selector).forEach((el) => obs.observe(el));
    });

    return () => {
      cancelAnimationFrame(raf);
      obs.disconnect();
    };
  }, [selector]);
}
